import React from "react";

import { Outlet } from "react-router-dom-v5-compat";

export const BustleLayout = () => {
  return (
    <div className="bg-bustle-pink-icing text-bustle-chalkboard min-h-screen h-full md:px-32 px-16  py-32">
      <Outlet />
    </div>
  );
};
